import { useState } from "react";
import { motion } from "framer-motion";
import { AnimatePresence } from "framer-motion";
import { useAuth } from "@/lib/auth";
import { Coins, TrendUp, Flask, GearSix, Buildings, Gift, Flag, MapPin } from "@phosphor-icons/react";
import EIICalc from "./EIICalc";
import SURECalc from "./SURECalc";
import RDCalc from "./RDCalc";
import S486CCalc from "./S486CCalc";
import KEEPCalc from "./KEEPCalc";
import UsRDCalc from "./UsRDCalc";
import UsOhioCalc from "./UsOhioCalc";
import EligibilityCheck from "./EligibilityCheck";
import TaxHistory from "./TaxHistory";
import TaxConfigModal from "./TaxConfigModal";

const TABS = [
  { id: "eii", label: "EII", icon: Coins },
  { id: "sure", label: "SURE", icon: TrendUp },
  { id: "rd", label: "R&D", icon: Flask },
  { id: "s486c", label: "486C", icon: Buildings },
  { id: "keep", label: "KEEP", icon: Gift },
  { id: "us_rd", label: "US R&D", icon: Flag },
  { id: "us_ohio", label: "Ohio", icon: MapPin },
];

export default function TaxReliefs() {
  const { user } = useAuth();
  const [tab, setTab] = useState("eii");
  const [refreshKey, setRefreshKey] = useState(0);
  const [configOpen, setConfigOpen] = useState(false);
  const bump = () => setRefreshKey((k) => k + 1);
  const isOwner = user?.role === "owner";

  return (
    <div className="space-y-8">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <div className="eyebrow mb-2">Tax Reliefs</div>
          <h1 className="font-display text-4xl">Irish tax-relief calculators</h1>
          <p className="text-white/60 text-sm mt-2">EII · SURE · R&D. Estimate relief, screen eligibility, and keep a documented trail for Revenue and your accountant.</p>
        </div>
        {isOwner && (
          <button onClick={() => setConfigOpen(true)} className="btn-ghost text-sm" data-testid="btn-tax-config"><GearSix size={16} /> Edit tax rules</button>
        )}
      </div>

      <EligibilityCheck />

      <div className="flex flex-wrap gap-2 border-b border-white/5 pb-1">
        {TABS.map((t) => (
          <button key={t.id} data-testid={`tax-tab-${t.id}`} onClick={() => setTab(t.id)}
            className={`flex items-center gap-2 px-4 py-2.5 rounded-t-lg text-sm transition-colors ${tab === t.id ? "bg-white/8 text-white border-b-2 border-[#FFB020]" : "text-white/55 hover:text-white/85"}`}>
            <t.icon size={16} weight="duotone" /> {t.label}
          </button>
        ))}
      </div>

      <motion.div key={tab} initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }}>
        {tab === "eii" && <EIICalc onSaved={bump} />}
        {tab === "sure" && <SURECalc onSaved={bump} />}
        {tab === "rd" && <RDCalc onSaved={bump} />}
        {tab === "s486c" && <S486CCalc onSaved={bump} />}
        {tab === "keep" && <KEEPCalc onSaved={bump} />}
        {tab === "us_rd" && <UsRDCalc onSaved={bump} />}
        {tab === "us_ohio" && <UsOhioCalc onSaved={bump} />}
      </motion.div>

      <TaxHistory refreshKey={refreshKey} />

      <AnimatePresence>
        {configOpen && <TaxConfigModal onClose={() => setConfigOpen(false)} />}
      </AnimatePresence>
    </div>
  );
}
